<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.03499 0.708375V9.58705H0.5V0.708375H3.03499ZM4.30665 0.708375V9.62187C5.24668 9.92205 6.20134 12.1191 6.41801 14.5067L6.4704 15.0834H7.04927C8.20406 15.0834 8.81758 15.0132 9.49828 14.6733C10.5069 14.1676 11.0633 13.1808 11.0633 11.701V10.4326H13.176C13.882 10.4326 14.5497 10.1116 14.9907 9.55998C15.4317 9.0084 15.5983 8.28613 15.4433 7.59696L14.3025 2.52343C14.0639 1.46229 13.1222 0.70836 12.0352 0.708375H4.30665Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
@Component
export default class FilledDislikeIcon extends Vue {}
</script>
